export enum UserRolesDto {
  ADMIN = 'ADMIN',
  USER = 'USER',
}
